/**
 * Delay execution of callback.
 */
var delay = (function() {
  var timer = 0;
  return function(callback, ms){
    clearTimeout (timer);
    timer = setTimeout(callback, ms);
  };
})();

function image_upload_handler (blobInfo, progress)
{
  var dfd = $.Deferred();
  var formData = new FormData();
  formData.append('_token', $('meta[name=csrf_token]').prop('content'));
  formData.append('file', blobInfo.blob(), blobInfo.filename());

  var ajaxData = {
    url: laroute.route('core.embed.image'),
    type: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    xhr: function() {
      var xhr = new window.XMLHttpRequest();
      xhr.upload.onprogress = function(e){
        progress(e.loaded / e.total * 100);
      }

      return xhr;
    }
  };

  $.ajax(ajaxData)
    .done(function(json) {
      if (json.location) {
        dfd.resolve(json.location);
      } else {
        dfd.reject(json.message || Lang.get('messages.error_embed_image'));
      }
    })
    .fail(function(){
      dfd.reject(Lang.get('messages.error_embed_image'));
    });

  return dfd.promise();
}

const mergeConfigs = (...configs) => {
  let callbacks = {
    setup: null,
  };

  for (const key in callbacks) {
    callbacks[key] = (...args) => {
      for (const c of configs) {
        if (typeof c !== "undefined" && c.hasOwnProperty(key)) c[key].call(undefined, ...args);
      }
    }
  }

  return $.extend(true, {}, ...configs, callbacks);
}

export {delay, image_upload_handler, mergeConfigs};
